import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Loader2, Terminal } from 'lucide-react';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[50vh] flex flex-col items-center justify-center p-4 font-mono">
        <div className="flex items-center gap-2 mb-6 text-text-secondary font-bold text-xl animate-pulse">
          <Terminal size={24} /> MacroDash / Authenticating
        </div>
        <Loader2 size={32} className="animate-spin text-text-tertiary" />
        <p className="mt-8 text-xs text-text-tertiary">Verifying your identity...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
